/**
 * Canonical "all specials for a store" preset.
 */
export const ALL_STORE_SPECIALS_OPTS = {
  appMode: 'default' as const,
  includeHidden: true,
  perPage: 1000,
};
